<template>
  <modal size="2xl" @close="$emit('close')" :close-on-click="false">
    <form class="flex flex-wrap w-full" @submit.prevent="submit">
      <div class="w-full md:w-1/2 mb-2 px-2">
        <nx-input
          v-model="name"
          :errors="form.errors"
          placeholder="Tassadar"
          id="name"
          type="text"
          label="Your Name"
          maxlength="100"
          :focus="true"
        />
      </div>

      <div class="w-full md:w-1/2 mb-2 px-2">
        <nx-input
          v-model="username"
          :errors="form.errors"
          placeholder="life4aiur"
          id="username"
          type="text"
          label="Username"
          minlength="3"
          maxlength="20"
        />
      </div>

      <div class="w-full mb-2 px-2">
        <nx-input
          v-model="email"
          :errors="form.errors"
          placeholder="tassadar@aiur.com"
          id="email"
          type="email"
          label="Your Email"
          maxlength="255"
        />
      </div>

      <div class="flex flex-wrap w-full mb-2">
        <div class="w-1/2 mb-2 px-2 md:mb-0">
          <nx-input
            v-model="password"
            :errors="form.errors"
            placeholder="3nT4roAdun"
            id="password"
            type="password"
            label="Password"
            minlength="8"
            maxlength="30"
          />
        </div>

        <div class="w-1/2 px-2">
          <nx-input
            v-model="password_confirmation"
            :errors="form.errors"
            placeholder="3nT4roAdun"
            id="password_confirmation"
            type="password"
            label="Password Confirmation"
            minlength="8"
            maxlength="30"
          />
        </div>

        <p
          v-if="!form.errors.has('password')"
          class="text-sm mt-1 px-2 text-blue-8"
        >Must be at least 8 characters long and include lowercase, uppercase and numbers.</p>
      </div>

      <div class="w-full px-2">
        <div class="mb-2">
          <label for="accept" class="inline-flex items-center">
            <input
              type="checkbox"
              class="form-checkbox text-blue-5"
              v-model="accept"
              id="accept"
              @input="form.errors.clear('accept')"
            />
            <span class="ml-2">
              I have read and accept both the
              <router-link
                class="text-blue-8 hover:text-blue-6"
                :to="{name: 'terms'}"
                target="_blank"
              >Terms of Use</router-link>&nbsp;&
              <router-link
                class="text-blue-8 hover:text-blue-6"
                :to="{name: 'privacy'}"
                target="_blank"
              >Privacy Policy</router-link>.
            </span>
          </label>
          <p
            v-if="form.errors.has('accept')"
            class="text-sm text-red-8 mt-1 pl-1"
          >You must accept the Terms of Use & Privacy Policy.</p>
        </div>
      </div>

      <div class="w-full mb-4 px-2 | recaptcha">
        <captcha @response="catpchaResponse" :errors="form.errors" id="recaptcha" ref="recaptcha"></captcha>
      </div>

      <div class="w-full text-center">
        <nx-button
          type="secondary"
          native-type="submit"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Register' }}</nx-button>
      </div>
    </form>
  </modal>
</template>

<script>
import Form from "form-backend-validation"

export default {
  name: "RegisterForm",
  data() {
    return {
      form: new Form(),
      name: "",
      username: "",
      email: "",
      password: "",
      password_confirmation: "",
      recaptcha: "",
      accept: false,
      loading: false
    }
  },
  methods: {
    async submit() {
      this.loading = true
      this.form.errors.clear()
      await this.$auth.register({
        data: {
          name: this.name,
          username: this.username,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          recaptcha: this.recaptcha,
          accept: this.accept
        },
        success: function() {
          this.$toasted.success("You have sucessfully registered an account. Please login to continue.")
          this.$emit("success")
          this.recaptcha = ""
          this.$refs.recaptcha.reset()
          this.loading = false
        },
        error: function(data) {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          } else {
            this.$error.generic()
          }
          this.recaptcha = ""
          this.$refs.recaptcha.reset()
          this.loading = false
        },
        redirect: null
      })
    },
    catpchaResponse(response) {
      this.form.errors.clear("recaptcha")
      this.recaptcha = response
    }
  }
}
</script>

